
import { useQuery } from "@tanstack/react-query";
import { fetchClassifications } from "./classifications/api/classificationQueries";
import { useClassificationMutations } from "./classifications/mutations/useClassificationMutations";

export function useClassifications() {
  const { data: allClassifications, isLoading, error } = useQuery({
    queryKey: ['asset-classifications'],
    queryFn: fetchClassifications
  });

  const mutations = useClassificationMutations(allClassifications);

  return {
    allClassifications,
    isLoading,
    error,
    ...mutations
  };
}
